import { CalendarTimezoneData } from "../types/calendarTimezone.type";

export class CalendarTimezoneTransformer {
  static optionsTransformer() {
    return (timezones: CalendarTimezoneData[]) => {
      return timezones.map((timezone) => {
        return {
          value: timezone.id,
          label: `${timezone.display_name || timezone.identifier} (GMT${formatTimezoneAcronym(timezone.acronym)})`,
        };
      });
    };
  }
}

export const formatTimezoneAcronym = (acronym: string) => `${Number(acronym) < 0 ? '' : '+'}${Number(acronym)}`
